import { ActionContext } from "vuex/types";
import { SnackQueue as Queue } from "@/plugins/SnackQueue";
import { downloadFile, exportFiles } from "@/utils/fileUtility";
import {
  IDownloadFileQueue,
  IDownloadFileSocket,
  IDownloadFileBatch
} from "@/store/types/file-type";
import { RootState } from "@/store/types/root";

const state = {
  listDownloadFiles: [] as IDownloadFileQueue[]
};

type State = typeof state;

const mutations = {
  setItemDownload: (state: State, file: IDownloadFileQueue) => {
    state.listDownloadFiles.push(file);
  },

  clearListDownloadFiles: (state: State) => {
    state.listDownloadFiles = [];
  },

  checkDoneDownloadFiles: (state: State) => {
    const hasPendingFile = state.listDownloadFiles.some(
      file => file.status === "pending"
    );
    if (!hasPendingFile) {
      Queue.open({
        id: "download_files",
        canClose: true
      });
    }
  }
};

const actions = {
  setCancelDownloadFile: (
    { commit, state }: ActionContext<State, RootState>,
    fileIndex: string | number
  ) => {
    if (fileIndex === -1) {
      state.listDownloadFiles.forEach(file => {
        if (file.status === "pending") {
          file.status = "abort";
          file.abort?.();
        }
      });
      Queue.open({
        id: "download_files",
        canClose: true
      });
    } else {
      const file = state.listDownloadFiles.find(
        file => file.file_index === fileIndex
      );
      if (file) {
        file.status = "abort";
        file.abort?.();
      }
    }
    commit("checkDoneDownloadFiles");
  },

  startDownload: async (
    { commit, dispatch, getters }: ActionContext<State, RootState>,
    fileData: IDownloadFileSocket
  ) => {
    const fileObject = getters.getFileByUUID(fileData.file_index);
    if (!fileData.file) {
      fileObject.status = "error";
      return;
    }
    fileObject.attachment_name = fileData.attachment_name;
    fileObject.url = fileData.file;
    fileObject.status = "done";
    fileObject.download = function() {
      downloadFile(fileObject);
    };
    downloadFile(fileObject);
    if (fileObject.report) fileObject.name = fileData.attachment_name;
    else
      setTimeout(() => {
        if (fileData.file) dispatch("removeFileSubject", fileData.file);
      }, fileData.deleteTime || 6e4);
    commit("checkDoneDownloadFiles");
  },

  startDownloadBatch: async (
    { commit, getters }: ActionContext<State, RootState>,
    fileData: IDownloadFileBatch
  ) => {
    const fileObject = getters.getFileByUUID(fileData.file_index);
    fileObject.attachment_name = "relatorio.pdf";
    fileObject.name = "Lote DOE compactado";
    Object.entries(fileData.files).forEach(report =>
      fileObject.list.push({
        report: true,
        origin: {
          entity: getters.getPartsById(parseInt(report[0]))
        },
        file_editable: report[1],
        name: "relatorio.pdf"
      })
    );

    fileObject.url = fileData.files;
    fileObject.status = "done";
    fileObject.download = function() {
      exportFiles(fileObject.list, true);
    };
    exportFiles(fileObject.list, true);
    commit("checkDoneDownloadFiles");
  }
};

const getters = {
  getListDownloadFiles: (state: State) => state.listDownloadFiles,
  getFileByUUID: (state: State) => (uuid: string) =>
    state.listDownloadFiles.find(file => file.file_index === uuid)
};

export default {
  state,
  mutations,
  actions,
  getters
};
